import { useCurrentBreakpoint } from "@jti/ui/hooks/useCurrentBreakpoint";

import { DESKTOP_MAX_CHARACTERS, TABLET_BREAKPOINTS, TABLET_MAX_CHARACTERS } from "./constants";

export const useMaxProductCharactersLength = () => {
  const { specificBreakpoint } = useCurrentBreakpoint();

  const isTablet = TABLET_BREAKPOINTS.includes(specificBreakpoint as (typeof TABLET_BREAKPOINTS)[number]);

  return isTablet ? TABLET_MAX_CHARACTERS : DESKTOP_MAX_CHARACTERS;
};
